import { useEffect, useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { get } from 'lodash'
import { useLazyGetPGUserInfoQuery, useLazyGetPaymentStatusQuery } from 'api/payment-gateway/paymentGateway'

const usePaymentProvider = () => {
  const businessId = useSelector(state => get(state, 'LoginPersist.selectedLoginDetails.businessId'), shallowEqual)
  // The gateway follows the selected account's business unit, so the provider must be resolved
  // per account, not per tenant. Payment status stays tenant-level by design.
  const accountId = useSelector(state => get(state, 'LoginPersist.selectedLoginDetails.accountId'), shallowEqual)
  const [getPGUserInfo, { data: pguserInfoData }] = useLazyGetPGUserInfoQuery()
  const [getPaymentStatus, { data: paymentStatusData }] = useLazyGetPaymentStatusQuery()
  const isFortis = useMemo(() => get(pguserInfoData, 'userInfo.pgConnectorType') === 'FORTIS', [pguserInfoData])
  const isInactive = useMemo(() => get(paymentStatusData, 'disabled') === true, [paymentStatusData])

  useEffect(() => {
    if (businessId) {
      getPGUserInfo({ businessId, accountId })
      getPaymentStatus({ businessId })
    }
  }, [businessId, accountId])

  return { isFortis, isInactive }
}

export default usePaymentProvider
